import { GetSelfAppCategoryAveragesSummaryApplicationService } from '../../../../src/core/application/services/team-metrics/category/get-self-app-category-averages-summary.application-service';
import { InternalServerErrorException } from '../../../common/exceptions/exceptions';
import { LogManager } from '../../../common/port/log/log.manager.port';
import { GetSelfAppCategoryAveragesSummaryRequestDto } from '../../../../src/interface/dtos/team-metrics/category/get-self-app-category-averages-summary.request.dto';
import { SelfAppCategoryAveragesSummaryEntity } from '../../../../src/core/domain/entities/team-metrics/category/self-app-category-average-summary.entity';

export class GetSelfAppCategoryAveragesSummaryQuery {
  constructor(
    protected readonly logManager: LogManager,
    protected readonly service: GetSelfAppCategoryAveragesSummaryApplicationService
  ) {}
  async execute(
    props: GetSelfAppCategoryAveragesSummaryRequestDto
  ): Promise<SelfAppCategoryAveragesSummaryEntity> {
    try {
      return await this.service.execute(props);
    } catch (error) {
      throw new InternalServerErrorException(error);
    }
  }
}
